export const types = {
    UPDATE_CHECKLIST_FORM_FIELD: "UPDATE_CHECKLIST_FORM_FIELD",
};

export const updateChecklistFormField = (name, value) => ({
    type: types.UPDATE_CHECKLIST_FORM_FIELD,
    payload: { name, value },
});
export const updateChecklistFormFieldData = (data) => ({
    type: types.UPDATE_CHECKLIST_FORM_FIELD,
    payload: { data},
});